<template lang="html">
  <d-form @submit.prevent="save" :validated="hasErrors">
    <d-form-row>

      <!-- Nome -->
      <d-col md="6" class="form-group mb-0">
        <label for="name">Nome</label>
        <d-form-input
          :state="hasErrorFiled('name')"
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.name"
          @change="setSlug"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>
      <!-- Slug -->
      <d-col md="6" class="form-group mb-0">
        <label for="name">Slug</label>
        <d-form-input
          :state="hasErrorFiled('slug')"
          type="text"
          id="slug"
          placeholder="Slug"
          v-model="model.slug"
        />
        <d-form-invalid-feedback>Slug é obrigatório</d-form-invalid-feedback>
      </d-col>
      <d-col md="12" class="form-group">
        <a class="preview" :href="model.preview" target="_blank">{{model.preview}}</a>
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Resume -->
      <d-col md="12" class="form-group">
        <label for="feResume">Resumo</label>
        <d-form-input type="text" v-model="model.excerpt" id="feResume" placeholder="Resumo" />
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Product Url -->
      <d-col md="12" class="form-group">
        <label for="feProductUrl">Link do produto no site</label>
        <d-form-input type="text" v-model="model.product_url" id="feProductUrl" placeholder="http://castelatto.com.br/produto" />
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Description -->
      <d-col md="12" class="form-group">
        <label for="feDescription">Descrição</label>
        <editor ref="comment" :model.sync="model.description" placeholder="Comentário"></editor>
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Is New -->
      <d-col cols="6" md="3" class="form-group">
        <label for="feGenerate">Gerar audio</label>
        <d-checkbox toggle @change="toggleAudio" :checked="hasGenerateAudio" class="custom-toggle-sm">Sim</d-checkbox>
      </d-col>
      <!-- Show player -->
      <d-col cols="6" md="9" class="form-group">
        <label for="feGenerate">Mostrar player</label>
        <d-checkbox toggle @change="toggleShowPlayer" :checked="(model.show_player === 1)" class="custom-toggle-sm">Sim</d-checkbox>
      </d-col>
      <!-- Url Audio -->
      <d-col md="6" class="form-group" v-if="typeof model.audio == 'string'">
        <label for="urlAudio">Player do áudio</label>
        <vue2-mp3-player
          class="thumbnail px-2"
          :src="model.audio"
          :ui="{icons:{play:'fa-play-circle'}, labels:{play: 'Play', pause: 'Pause'}, classes:{btn:'btn btn-default'}}"
        ></vue2-mp3-player>
      </d-col>
      <!-- Audio -->
      <d-col md="6" class="form-group" v-if="!hasGenerateAudio">
        <label for="feAudio">Upload de áudio</label>
        <div class="custom-file mb-3">
          <input type="file" class="custom-file-input" id="feAudio" ref="file" @change="choseFile()"/>
          <label class="custom-file-label" for="feAudio">{{ audio.name }}</label>
          <small>Caso não seja feito o upload o áudio será gerado.</small>
        </div>
      </d-col>
      <!-- Is New -->
      <d-col md="6" class="form-group" v-if="hasGenerateAudio">
        <label for="feNew">Vozes</label>
        <d-select v-model="model.voice" class="form-control" :state="hasErrorVoice()">
          <option value="Vitoria">Vitória</option>
          <option value="Ricardo">Ricardo</option>
          <option value="Camila">Camila</option>
        </d-select>
      </d-col>
    </d-form-row>
    <d-form-row>
      <!-- Is New -->
      <d-col md="6" class="form-group">
        <label for="feNew">Lançamento?</label>
        <d-checkbox toggle @change="toggleIsNew" :checked="(model.is_new === 1)" class="custom-toggle-sm">Sim</d-checkbox>
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Imagem -->
      <d-col md="12" class="form-group">
        <label for="feImage">Galeria</label>
        <gallery-images :model.sync="model.images" @uploadFiles="uploadFiles"/>
      </d-col>
    </d-form-row>
  </d-form>

</template>

<script>
import { mapActions } from 'vuex';
import Vue2Mp3Player from 'vue2-mp3-player';
import mixin from '_common/mixins/ValidateForm';
import Editor from '_shared/Editor.vue';
import GalleryImages from '_shared/GalleryImages.vue';
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ProductService from '_services/rest/modules/product';
import { stringfy, openPdf, catchPdf } from '_utils';
import { MODEL, _SAVE_PRODUCT_SUCCESS_, _LOAD_MODEL_ } from './ProductModel';

export default {
  name: 'product-form',
  mixins: [mixin],
  props: {
    model: {
      type: Object,
      default: MODEL,
    },
  },
  components: {
    Loader,
    Editor,
    Vue2Mp3Player,
    GalleryImages,
  },
  data() {
    return {
      audio: { name: 'Selecione um áudio...' },
      loading: false,
      hasGenerateAudio: true,
      validadeVoice: false,
      errors: {
        name: { required: false },
        slug: { required: false },
      },
    };
  },
  computed: {
  },
  watch: {},
  methods: {
    ...mapActions([
      'setToggle',
      'setProduct',
      'activeAlert',
      'getProductUnits',
    ]),
    choseFile() {
      [this.audio] = this.$refs.file.files;
      this.model.audio = this.audio;
    },
    hasErrorVoice() {
      if (this.submitted) {
        if (!this.checkAudio()) {
          return 'invalid';
        }
        return 'valid';
      }
      return null;
    },
    checkAudio() {
      if (this.hasGenerateAudio) {
        return (this.model.voice);
      }
      return true;
    },
    printQr() {
      ProductService.printQr(this.model.id)
        .then(response => openPdf(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }));
    },
    save() {
      if (this.checkForm() && this.checkAudio()) {
        this.updateGalleryOrder();
        ProductService.save(this.model)
          .then(response => {
            this.activeAlert({ message: 'Produto salvo com sucesso', theme: 'success' });
            this.setProduct(response);
            Events.$emit('uploaded:files', true);
            Events.$emit(_SAVE_PRODUCT_SUCCESS_, response);
          })
          .catch(error => {
            this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
          });
      }
      return null;
    },
    setSlug() {
      this.model.slug = stringfy(this.model.name);
    },
    toggleIsNew() {
      this.model.is_new = (this.model.is_new === 1) ? 0 : 1;
    },
    toggleShowPlayer() {
      this.model.show_player = (this.model.show_player === 1) ? 0 : 1;
    },
    toggleAudio() {
      this.hasGenerateAudio = !this.hasGenerateAudio;
      this.model.voice = (this.hasGenerateAudio) ? 'Ricardo' : 'null';
    },
    updateGalleryOrder() {
      this.model.images = this.model.images.map((image, index) => {
        image.order = index;
        return image;
      });
    },
    uploadFiles(values) {
      this.model.images = this.model.images.concat(values);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, product => {
      this.hasGenerateAudio = (product.voice !== 'null' && typeof (product.audio) !== 'undefined');
    });
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
.thumbnail {
  border-radius: 4px;
  padding: 2px 0;
  /deep/ .song-title {
    margin-left: 0;
  }
}
.preview {
  font-style: italic;
  &:hover {
    text-decoration: underline;
  }
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
